import { render } from "./Root.vue?vue&type=template&id=9713d4a8&scoped=true"
import script from "./Root.vue?vue&type=script&lang=ts"
export * from "./Root.vue?vue&type=script&lang=ts"

import "./Root.vue?vue&type=style&index=0&id=9713d4a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9713d4a8"

export default script